var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-backdrop",on:{"click":_vm.hideModal}},[_c('div',{staticClass:"modal-container",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }